module.exports = __webpack_public_path__ + "img/iverson-react-native.dfd1ef68.png";